import { z } from 'zod'
import { ExclusiveOfferType } from '~library/enums'

export const getExclusiveOfferTypeListResponseSchema = z.object({
  /** 分類 */
  type: z.array(z.enum(ExclusiveOfferType))
})

export interface GetExclusiveOfferTypeListResponse
  extends z.infer<typeof getExclusiveOfferTypeListResponseSchema> {}
